import logo from './logo.svg';
import './App.css';
import react, { useEffect } from 'react'
import Header from './components/home/header/header';
import { BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import HomePage from './components/pageContent/homePage';
import Footer from './components/homes/Footer';

import AboutP from './components/about/AboutP';
import PackP from './components/Pack/Packp';
import Contact from './components/contact/Contact';

import AOS from "aos"
import "aos/dist/aos.css"
import Head from './components/home/header/head';
import SericeP from './components/services/ServiceP';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


function App() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      offset: 100,
    });
    AOS.refresh();
  }, [])
  return (
    <>
      <Router>
        <ScrollToTop />
        <Header />
        <Switch>
          <Route path='/' exact component={HomePage} />
          <Route path='/blog' exact component={SericeP} />
          <Route path='/About' exact component={AboutP} />
          <Route path='/Pack' exact component={PackP} />
          <Route path='/Contact' exact component={Contact} />

        </Switch>

        <Footer />  </Router>

    </>
  );
}

export default App;
